module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit_note":"Edit note","remove_from_product":"Remove from product","remove_from_product_confirmation":"Are you sure you want to remove this note from this product?"},"id":{"edit_note":"Edit nota","remove_from_product":"Hapus dari produk","remove_from_product_confirmation":"Yakin ingin hapus not dari produk ini?"}}')
  delete Component.options._Ctor
}
